/* eslint-disable no-mixed-operators */

export default class UUID {
    private static _lut: string[] = [];

    // This is a function definition that immediately invokes itself
    // to initialize the _lut array.
    private static _initialize = (() => {
        for (let i = 0; i < 256; i++) {
            UUID._lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
        }
    })();

    public static generate(): string {
        const d0 = Math.random() * 0xffffffff | 0;
        const d1 = Math.random() * 0xffffffff | 0;
        const d2 = Math.random() * 0xffffffff | 0;
        const d3 = Math.random() * 0xffffffff | 0;
        return UUID._lut[d0 & 0xff] + UUID._lut[d0 >> 8 & 0xff] + UUID._lut[d0 >> 16 & 0xff] + UUID._lut[d0 >> 24 & 0xff] + '-' +
            UUID._lut[d1 & 0xff] + UUID._lut[d1 >> 8 & 0xff] + '-' + UUID._lut[d1 >> 16 & 0x0f | 0x40] + UUID._lut[d1 >> 24 & 0xff] + '-' +
            UUID._lut[d2 & 0x3f | 0x80] + UUID._lut[d2 >> 8 & 0xff] + '-' + UUID._lut[d2 >> 16 & 0xff] + UUID._lut[d2 >> 24 & 0xff] +
            UUID._lut[d3 & 0xff] + UUID._lut[d3 >> 8 & 0xff] + UUID._lut[d3 >> 16 & 0xff] + UUID._lut[d3 >> 24 & 0xff];
    }
}